// Dialog.js
import React, { useEffect } from "react"
import * as styles from "./dialog.module.css"
import Heading from "../text/heading/heading"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"

const Dialog = ({
  isOpen = false,
  onClose = () => {},
  title = "",
  children = null,
  buttonText = "",
  onButtonClick = () => {},
  buttonDiabled = false
}) => {
  // Prevent background scrolling when the dialog is open

  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativeDirectory: { in: ["common/close"] }
        }
      ) {
        nodes {
          id
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  `)

  const closeIcon = data.allFile.nodes[0]
  useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflow = "hidden"

      const handleEsc = (event) => {
        if (event.key === "Escape") {
          onClose()
        }
      }

      document.addEventListener("keydown", handleEsc)
      return () => {
        document.removeEventListener("keydown", handleEsc)
      }
    } else {
      document.documentElement.style.overflow = "auto"
    }

    return () => {
      document.documentElement.style.overflow = "auto"
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleOverlayClick = event => {
    if (event.target.id === "dialog-overlay") {
      onClose()
    }
  }

  return (
    <div
      id="dialog-overlay"
      onClick={handleOverlayClick}
      className="fixed inset-0 bg-black bg-opacity-50 h-screen w-full"
      style={{ zIndex: 100 }}
    >
      <div
        id="dialog-overlay"
        className="h-screen w-full p-4 flex items-center"
      >
        <div
          id="dialog-overlay"
          className="w-full flex items-center gap-3 justify-center flex-col md:flex-row"
        >
          <div
            className="cursor-pointer w-[35px] ml-auto mt-[-20px] md:hidden "
            onClick={onClose}
          >
            <GatsbyImage
              image={getImage(closeIcon?.childImageSharp)}
              alt="Close"
              className="w-full h-full"
            />
          </div>
          <div
            className={`bg-white w-full max-w-[900px] rounded-xl md:rounded-2xl shadow-lg overflow-auto max-h-[70vh] md:max-h-[90vh]`}
          >
            {title && (
              <Heading
                variant="h1"
                className="border-b border-[#ddd] pb-5 mb-4"
              >
                {title}
              </Heading>
            )}
            {/* Dialog Content */}
            <div>{children}</div>
            {/* Optional Button */}
            {buttonText && (
              <div className="mt-4">
                <button
                  data-variant="primary"
                  className={`${styles.button}`}
                  onClick={onButtonClick}
                  disabled={buttonDiabled}
                >
                  {buttonText}
                </button>
              </div>
            )}
          </div>
          {/* Close button Desktop */}
          <div
            className="cursor-pointer w-[50px] hidden md:block mb-auto"
            onClick={onClose}
          >
            <GatsbyImage
              image={getImage(closeIcon?.childImageSharp)}
              alt="Close"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dialog
